goog.provide('el8.ptdata.model.note.visitAlertSet');

goog.require('el8.model.base');


// ---------------------
// * VISIT NOTE ALERT *
// ---------------------
(function() {
    
    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('nqfCode');
    _class.addStringProperty('status');
    
    _class.prototype.populate = function(spec) {
        spec = spec || {};
        var that = this;
        this.parent.populate.call(this, spec);        
    };
    
    el8.ptdata.model.note.visitAlert = function(spec) {
        spec.model_class = "VisitNoteAlert";
        return new _class(spec);
    };

})();

el8.ptdata.model.note.visitAlertSet = function(_data) {
    
    var _set = new el8_EntitySet({
        model: function(spec) {
            return el8.ptdata.model.note.visitAlert(spec);
        }
    });
    
    _set.getByNqfCode = function(code) {
        var all = _set.all(true);
        for (var i=0; i<all.length; i++) {
            if (all[i].getNqfCode() === code) {
                return all[i];
            }
        }
        return null;
    };
    
    _set.create(_data);
    return _set;
};
    

